// import React, { useEffect, useState } from "react";
// import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
// import { Container, Row, Col, Button, Table } from "react-bootstrap";
// import ThemeTable from "../component/ThemeTable";
// import PurchaseService from "../services/Purchase";
// import Loader from "../component/Loader";
// import { useNavigate } from "react-router-dom";
// import DatePicker from "../component/DatePicker";
// import InputField from "../component/InputField";
// import PrimaryGradientButton from "../component/PrimaryGradientButton";
// import Form from "react-bootstrap/Form";
// import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
// import toast from "react-hot-toast";
// import SelectDropDown from "../component/SelectDropDown";
// import { useMemo } from "react";
// import OtherService from "../services/Other";
// import NoData from "../component/NoData";
// const MemberPerformance = () => {
//   // const allStatus = [
//   //   {
//   //       id: 'all',
//   //       title: 'All',
//   //   },
//   //   {
//   //       id: 'active',
//   //       title: 'Active',
//   //   },
//   //   {
//   //       id: 'inactive',
//   //       title: 'Inactive',
//   //   },
//   //   {
//   //     id: 'dormant',
//   //     title: 'Dormant',
//   //   }
//   // ];
//   const [allStatus, setAllStatus] = useState([{ id: 'all', title: 'All' }]);

//   const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");

//   const isHierDesc = userInfo?.description || null;

//   const [loading, setLoading] = useState(true);
//   const [purchaseList, setIsPurchaseList] = useState([]);
//   const [isDataFound, setIsDataFound] = useState(false);
//   const [conversionFactor, setConversionFactor] = useState(0.5);
//   const [tseSectionBlock, setTseSectionBlock] = useState(false);
//   const [isSearchMobile, setIsSearchMobile] = useState("");
//   const [searchField, setSearchField] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchStatus, setSearchStatus] = useState(allStatus[0]);
//   const [isSearchSingleData, setIsSearchSingleData] = useState(false);
//   const [isSearchPurchaseDate, setIsSearchPurchaseDate] = useState("");
//   const [isTableDataFound, setIsTableDataFound] = useState(false);
//   const [allMarked, setAllMarked] = useState([]);
//   const [allMItems, setAllMItems] = useState([]);
//   const [status, setStatus] = useState(allStatus[0]);
//   // const [pageNo, setPageNo] = useState(1);

//   // Load state from localStorage on component mount
//   useEffect(() => {
//     const savedSearchMobile = localStorage.getItem("isSearchMobile");
//     const savedSearchName = localStorage.getItem("isSearchName");
//     const savedSearchPurchaseDate = localStorage.getItem(
//       "isSearchPurchaseDate"
//     );

//     if (savedSearchMobile) setIsSearchMobile(savedSearchMobile);
//     if (savedSearchPurchaseDate)
//       setIsSearchPurchaseDate(savedSearchPurchaseDate);
//   }, []);

//   //Conversion
//   const ConversionFactorData = async () => {
//     const token = localStorage.getItem("access_token");
//     try {
//       const ConversionDataResponse = await PurchaseService.conversionFactor(
//         token
//       );

//         "ConversionDataResponse",
//         JSON.stringify(ConversionDataResponse)
//       );
//       if (ConversionDataResponse.success == true) {
//         setConversionFactor(
//           parseFloat(ConversionDataResponse.response.conversionDetails)
//         );
//       }
//       if (!isNaN(conversionFactor)) {
//         setConversionFactor(conversionFactor);
//       }
//     } catch (e) {

//     }
//   };

//   //Purchase List
//   const PurchaseListFetchData = async (
//   ) => {
//     try {

//         setLoading(true)
//       // (brandId, mobNum, fromDate, toDate, listType, influencerName, payload, limit, pageNo)
//       const responsePurchaseList =
//         await  OtherService.getMemberPerformance(
//           searchQuery,
//           'all'
//           // searchStatus.id
//         );

//       if (
//         responsePurchaseList.success == true &&
//         responsePurchaseList.response.data.length > 0
//       ) {
//         // const filteredData = responsePurchaseList.response.data.map(
//         //   (item, index) => {
//         //       return {
//         //         "Member ID.": item.memberId,
//         //         "Member Name": item.memberName,
//         //         "Mobile No": item.mobile_no,
//         //         "Orders": item.orderCount,
//         //         "Leads": item.leadCount,
//         //         "Volume": `${item.Volume} ${item.Volume_unit}`,
//         //       };
            
//         //   }
//         // );
//         const filteredData = responsePurchaseList.response.data
//           .filter((item) => {
//             if (searchStatus.id === 'all') return true;
//             return item.business_active?.toLowerCase() === searchStatus.id;
//           })
//           .map((item) => {
//             return {
//               "Member ID.": item.memberId,
//               "Member Name": item.memberName,
//               "Mobile No": item.mobile_no,
//               "Orders": item.orderCount,
//               "Leads": item.leadCount,
//               "Volume": `${item.Volume} ${item.Volume_unit}`,
//             };
//           });
//         const uniqueStatuses = [
//           ...new Set(responsePurchaseList.response.data.map(item => item.business_active?.toLowerCase()))
//         ];
//         const statusOptions = [{ id: 'all', title: 'All' }, ...uniqueStatuses.map(status => ({
//           id: status,
//           title: status.charAt(0).toUpperCase() + status.slice(1)
//         }))];
//         setAllStatus(statusOptions);
        

//         setIsPurchaseList(filteredData)
//         setLoading(false);

//       } else if (
//         responsePurchaseList.success == true &&
//         responsePurchaseList.response.status == true &&
//         responsePurchaseList.response.saleData.length == 0
//       ) {
//         setIsTableDataFound(false);
//         setIsSearchSingleData(true);
//         setLoading(false);
//       } else {
//         setIsTableDataFound(false);
//         setIsSearchSingleData(true);
//         setLoading(false);
//       }
//     } catch (e) {
//       console.error("e");
//     }
//   };

//   useEffect(() => {

//     // if (isHierDesc !== null) {
//     PurchaseListFetchData();
//     // }
//   }, [searchQuery, searchStatus]);

//   // useEffect(() => {
//   //   if(purchaseList.length > 0) {
//   //     const updatedList = purchaseList.map(item => {
//   //       
//   //       if(allMarked.includes(item["Transaction Id"].props.children)) {
//   //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={true} onChange={() => onChecked(item)} />, ...item}
//   //         return uItem;
//   //       } else {
//   //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={false} onChange={() => onChecked(item)} />, ...item}
//   //         return uItem;
//   //       }
//   //     })
//   //   }
//   // }, [allMarked, purchaseList])

//   const navigate = useNavigate();
 
//   const searchHandler = (e) => {
//     setSearchField(e.target.value);
//   };
//   const handleSearch = () => {
//     setSearchQuery(searchField);
//     setSearchStatus(status);
//   };
//   const handleClear = () => {
//     setStatus(allStatus[0]);
//     setSearchStatus(allStatus[0])
//     setSearchField("")
//     setSearchQuery("")
//   };

//   let headers = [];
//   if (purchaseList.length > 0) {
//     headers = Object.keys(purchaseList[0]);
//   }

//   return (
//     <>
//       {loading && <Loader />}

//       <BreadCrumbSecttion
//         pageTitle="Member Performance"
//         currentPageName="Member Performance"
//       />
//       <section className="padTop50">
//         <Container>
//           <Row>
//               <>
//                   <Col xs={12} lg={12}>
//                     <div className="searchBoxBlock my-4">
//                       <Row>
//                         <Col xs={12} lg={3}>
//                           <InputField
//                             inputFieldLabel="Search By Name, Phone or Member ID"
//                             onChange={searchHandler}
//                             value={searchField}
//                           />
//                         </Col>
//                         <Col xs={12} lg={3}>
//                           <SelectDropDown
//                             labelName="Filter by status"
//                             // requiredStar="*"
//                             options={allStatus}
//                             setSelectedValue={setStatus}
//                             selectedValue={status}
//                             // onChange={handleContentDistrictNameChange}
//                             page="searchFilter"
//                           />
//                         </Col>
//                         <Col xs={12} lg={3} className="mt-4">
//                           <Row>
//                             <Col xs={12} lg={6}>
//                               <PrimaryGradientButton
//                                 buttonText="Search"
//                                 onClick={handleSearch}
//                               />
//                             </Col>
//                             <Col xs={12} lg={6}>
//                               <PrimaryOutLineButton
//                                 outlinebuttonText="Clear"
//                                 onClick={handleClear}
//                               />
//                             </Col>
//                           </Row>
//                         </Col>
//                         <Col xs={12} lg={2} className="mt-4">
//                             <div className="batch-icon-card">
//                                 <span>Total</span>
//                                 <span>{purchaseList.length}</span>
//                             </div>
//                         </Col>
//                       </Row>
//                     </div>
//                   </Col>

//                 {purchaseList.length == 0 && loading == false && (
//                   <Col xs={12}>
//                     <NoData />
//                   </Col>
//                 )}
//                 {purchaseList.length == 0 && loading == true && (
//                   <Col xs={12}>
//                     <div className="success-message mb-3">Loading...</div>
//                   </Col>
//                 )}
//                 {purchaseList.length > 0 && (
//                   <Col xs={12} lg={12} className="purchaseListTable">
//                     {/* <ThemeTable data={purchaseList} onLoadMore={onLoadMore} /> */}

//                     <Table striped bordered hover responsive>
//                       <thead>
//                         <tr>
//                           {headers.length > 0 &&
//                             headers.map((header, index) => (
//                               <th key={index}>{header}</th>
//                             ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {purchaseList.length > 0 &&
//                           purchaseList.map((item, index) => {
//                             // 
//                             // const keysArray = Object.keys(item);
//                             // return (
//                             return (<tr
//                               key={index}
//                               // className={rowClickable ? "cursor-pointer" : ""}
//                             > <td>
//                               <div>{item["Member ID."]}</div>
//                             </td>
//                              <td>
//                               <div>{item["Member Name"]}</div>
//                             </td>
//                             <td
//                             >
//                               <div>{item["Mobile No"]}</div>
//                             </td>
//                             <td
//                             >
//                               <div>{item["Orders"]}</div>
//                             </td>
//                             <td
//                             >
//                               <div>{item["Leads"]}</div>
//                             </td>
//                             <td
//                             >
//                               <div>{item["Volume"]}</div>
//                             </td>
//                             </tr>)
//                           })}
//                       </tbody>
//                     </Table>
//                     {/* {visibleItemCount < data.length && ( */}

//                     {/* <Container>
//                       <Row className="justify-content-center">
//                         <Col xs={12} lg={3}>
//                           <PrimaryGradientButton
//                             onClick={onLoadMore}
//                             buttonText="Show More"
//                           />
//                         </Col>
//                       </Row>
//                     </Container> */}
//                     {/* )} */}
//                   </Col>
//                 )}
//               </>
            
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default MemberPerformance;

import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import PurchaseService from "../services/Purchase";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import DatePicker from "../component/DatePicker";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import Form from "react-bootstrap/Form";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import { useMemo } from "react";
import OtherService from "../services/Other";
import NoData from "../component/NoData";
const MemberPerformance = () => {
  // const allStatus = [
  //   {
  //       id: 'all',
  //       title: 'All',
  //   },
  //   {
  //       id: 'active',
  //       title: 'Active',
  //   },
  //   {
  //       id: 'inactive',
  //       title: 'Inactive',
  //   },
  //   {
  //     id: 'dormant',
  //     title: 'Dormant',
  //   }
  // ];
  const [allStatus, setAllStatus] = useState([{ id: 'all', title: 'All' }]);

  const [fullPurchaseList, setFullPurchaseList] = useState([]);

  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");

  const isHierDesc = userInfo?.description || null;
  const [loading, setLoading] = useState(true);
  const [purchaseList, setIsPurchaseList] = useState([]);
  const [isDataFound, setIsDataFound] = useState(false);
  const [conversionFactor, setConversionFactor] = useState(0.5);
  const [tseSectionBlock, setTseSectionBlock] = useState(false);
  const [isSearchMobile, setIsSearchMobile] = useState("");
  const [searchField, setSearchField] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchStatus, setSearchStatus] = useState(allStatus[0]);
  const [isSearchSingleData, setIsSearchSingleData] = useState(false);
  const [isSearchPurchaseDate, setIsSearchPurchaseDate] = useState("");
  const [isTableDataFound, setIsTableDataFound] = useState(false);
  const [allMarked, setAllMarked] = useState([]);
  const [allMItems, setAllMItems] = useState([]);
  const [status, setStatus] = useState(allStatus[0]);
  // const [pageNo, setPageNo] = useState(1);

  // Load state from localStorage on component mount
  useEffect(() => {
    const savedSearchMobile = localStorage.getItem("isSearchMobile");
    const savedSearchName = localStorage.getItem("isSearchName");
    const savedSearchPurchaseDate = localStorage.getItem(
      "isSearchPurchaseDate"
    );

    if (savedSearchMobile) setIsSearchMobile(savedSearchMobile);
    if (savedSearchPurchaseDate)
      setIsSearchPurchaseDate(savedSearchPurchaseDate);
  }, []);

  //Conversion
  const ConversionFactorData = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const ConversionDataResponse = await PurchaseService.conversionFactor(
        token
      );
      if (ConversionDataResponse.success == true) {
        setConversionFactor(
          parseFloat(ConversionDataResponse.response.conversionDetails)
        );
      }
      if (!isNaN(conversionFactor)) {
        setConversionFactor(conversionFactor);
      }
    } catch (e) {
    }
  };

  //Purchase List
  // const PurchaseListFetchData = async (
  // ) => {
  //   try {

  //       setLoading(true)
  //     // (brandId, mobNum, fromDate, toDate, listType, influencerName, payload, limit, pageNo)
  //     const responsePurchaseList =
  //       await  OtherService.getMemberPerformance(
  //         searchQuery,
  //         'all'
  //         // searchStatus.id
  //       );

  //     if (
  //       responsePurchaseList.success == true &&
  //       responsePurchaseList.response.data.length > 0
  //     ) {
  //       // const filteredData = responsePurchaseList.response.data.map(
  //       //   (item, index) => {
  //       //       return {
  //       //         "Member ID.": item.memberId,
  //       //         "Member Name": item.memberName,
  //       //         "Mobile No": item.mobile_no,
  //       //         "Orders": item.orderCount,
  //       //         "Leads": item.leadCount,
  //       //         "Volume": `${item.Volume} ${item.Volume_unit}`,
  //       //       };
            
  //       //   }
  //       // );
  //       const filteredData = responsePurchaseList.response.data
  //         .filter((item) => {
  //           if (searchStatus.id === 'all') return true;
  //           return item.business_active?.toLowerCase() === searchStatus.id;
  //         })
  //         .map((item) => {
  //           return {
  //             "Member ID.": item.memberId,
  //             "Member Name": item.memberName,
  //             "Mobile No": item.mobile_no,
  //             "Orders": item.orderCount,
  //             "Leads": item.leadCount,
  //             "Volume": `${item.Volume} ${item.Volume_unit}`,
  //           };
  //         });
  //       const uniqueStatuses = [
  //         ...new Set(responsePurchaseList.response.data.map(item => item.business_active?.toLowerCase()))
  //       ];
  //       const statusOptions = [{ id: 'all', title: 'All' }, ...uniqueStatuses.map(status => ({
  //         id: status,
  //         title: status.charAt(0).toUpperCase() + status.slice(1)
  //       }))];
  //       setAllStatus(statusOptions);
        

  //       setIsPurchaseList(filteredData)
  //       setLoading(false);

  //     } else if (
  //       responsePurchaseList.success == true &&
  //       responsePurchaseList.response.status == true &&
  //       responsePurchaseList.response.saleData.length == 0
  //     ) {
  //       setIsTableDataFound(false);
  //       setIsSearchSingleData(true);
  //       setLoading(false);
  //     } else {
  //       setIsTableDataFound(false);
  //       setIsSearchSingleData(true);
  //       setLoading(false);
  //     }
  //   } catch (e) {
  //     console.error("e");
  //   }
  // };
  const PurchaseListFetchData = async () => {
    try {
      setLoading(true);
      const responsePurchaseList = await OtherService.getMemberPerformance(searchQuery, 'all');
  
      if (responsePurchaseList.success === true && responsePurchaseList.response.data.length > 0) {
        const rawData = responsePurchaseList.response.data;
  
        // Store raw data for future filtering
        setFullPurchaseList(rawData);
  
        // Extract unique statuses for the dropdown
        const uniqueStatuses = [...new Set(rawData.map(item => item.business_active?.toLowerCase()))];
        const statusOptions = [{ id: 'all', title: 'All' }, ...uniqueStatuses.map(status => ({
          id: status,
          title: status.charAt(0).toUpperCase() + status.slice(1)
        }))];
        setAllStatus(statusOptions);
  
        // Apply initial filter
        const filteredData = filterPurchaseList(rawData, searchQuery, status.id);
        setIsPurchaseList(filteredData);
      } else {
        setIsTableDataFound(false);
        setIsSearchSingleData(true);
      }
  
      setLoading(false);
    } catch (e) {
      console.error("Error fetching member performance data");
      setLoading(false);
    }
  };
  useEffect(() => {
    PurchaseListFetchData();
  }, []);
  
  

  // useEffect(() => {

  //   // if (isHierDesc !== null) {
  //   PurchaseListFetchData();
  //   // }
  // }, [searchQuery, searchStatus]);

  // useEffect(() => {
  //   if(purchaseList.length > 0) {
  //     const updatedList = purchaseList.map(item => {

  //       if(allMarked.includes(item["Transaction Id"].props.children)) {
  //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={true} onChange={() => onChecked(item)} />, ...item}
  //         return uItem;
  //       } else {
  //         const uItem = {'Select': <input disabled={item.sale_status != 0 } type="checkbox" id="scales" name="scales" checked={false} onChange={() => onChecked(item)} />, ...item}
  //         return uItem;
  //       }
  //     })
  //   }
  // }, [allMarked, purchaseList])

  const navigate = useNavigate();
 
  const searchHandler = (e) => {
    setSearchField(e.target.value);
  };
  // const handleSearch = () => {
  //   setSearchQuery(searchField);
  //   setSearchStatus(status);
  // };

  const handleSearch = () => {
    setSearchQuery(searchField);
    const filteredData = filterPurchaseList(fullPurchaseList, searchField, status.id);
    setIsPurchaseList(filteredData);
  };
  
  useEffect(() => {
    if (fullPurchaseList.length > 0) {
      const filteredData = filterPurchaseList(fullPurchaseList, searchQuery, status.id);
      setIsPurchaseList(filteredData);
    }
  }, [status]);
  
  const handleClear = () => {
    setStatus(allStatus[0]);
    setSearchStatus(allStatus[0])
    setSearchField("")
    setSearchQuery("")
  };

  let headers = [];
  if (purchaseList.length > 0) {
    headers = Object.keys(purchaseList[0]);
  }

  // const filterPurchaseList = (data, status) => {
  //   if (status.id === 'all') return data;
  //   return data.filter(item => item.business_active?.toLowerCase() === status.id);
  // };

  const filterPurchaseList = (data, query, statusId) => {
    return data
      .filter(item => {
        const matchesStatus = statusId === 'all' || item.business_active?.toLowerCase() === statusId;
        const matchesSearch = query === '' ||
          item.memberId?.toLowerCase().includes(query.toLowerCase()) ||
          item.memberName?.toLowerCase().includes(query.toLowerCase()) ||
          item.mobile_no?.toLowerCase().includes(query.toLowerCase());
        return matchesStatus && matchesSearch;
      })
      .map(item => ({
        "Member ID.": item.memberId,
        "Member Name": item.memberName,
        "Mobile No": item.mobile_no,
        "Orders": item.orderCount,
        "Leads": item.leadCount,
        "Volume": `${item.Volume} ${item.Volume_unit}`,
      }));
  };
  
  

  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion
        pageTitle="Member Performance"
        currentPageName="Member Performance"
      />
      <section className="padTop50">
        <Container>
          <Row>
              <>
                  <Col xs={12} lg={12}>
                    <div className="searchBoxBlock my-4">
                      <Row>
                        <Col xs={12} lg={3}>
                          <InputField
                            inputFieldLabel="Search By Name, Phone or Member ID"
                            onChange={searchHandler}
                            value={searchField}
                          />
                        </Col>
                        <Col xs={12} lg={3}>
                          <SelectDropDown
                            labelName="Filter by status"
                            // requiredStar="*"
                            options={allStatus}
                            setSelectedValue={setStatus}
                            selectedValue={status}
                            // onChange={handleContentDistrictNameChange}
                            page="searchFilter"
                          />
                        </Col>
                        <Col xs={12} lg={3} className="mt-4">
                          <Row>
                            <Col xs={12} lg={6}>
                              <PrimaryGradientButton
                                buttonText="Search"
                                onClick={handleSearch}
                              />
                            </Col>
                            <Col xs={12} lg={6}>
                              <PrimaryOutLineButton
                                outlinebuttonText="Clear"
                                onClick={handleClear}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12} lg={2} className="mt-4">
                            <div className="batch-icon-card">
                                <span>Total</span>
                                <span>{purchaseList.length}</span>
                            </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                {purchaseList.length == 0 && loading == false && (
                  <Col xs={12}>
                    <NoData />
                  </Col>
                )}
                {purchaseList.length == 0 && loading == true && (
                  <Col xs={12}>
                    <div className="success-message mb-3">Loading...</div>
                  </Col>
                )}
                {purchaseList.length > 0 && (
                  <Col xs={12} lg={12} className="purchaseListTable">
                    {/* <ThemeTable data={purchaseList} onLoadMore={onLoadMore} /> */}

                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          {headers.length > 0 &&
                            headers.map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {purchaseList.length > 0 &&
                          purchaseList.map((item, index) => {

                            // const keysArray = Object.keys(item);
                            // return (
                            return (<tr
                              key={index}
                              // className={rowClickable ? "cursor-pointer" : ""}
                            > <td>
                              <div>{item["Member ID."]}</div>
                            </td>
                             <td>
                              <div>{item["Member Name"]}</div>
                            </td>
                            <td
                            >
                              <div>{item["Mobile No"]}</div>
                            </td>
                            <td
                            >
                              <div>{item["Orders"]}</div>
                            </td>
                            <td
                            >
                              <div>{item["Leads"]}</div>
                            </td>
                            <td
                            >
                              <div>{item["Volume"]}</div>
                            </td>
                            </tr>)
                          })}
                      </tbody>
                    </Table>
                    {/* {visibleItemCount < data.length && ( */}

                    {/* <Container>
                      <Row className="justify-content-center">
                        <Col xs={12} lg={3}>
                          <PrimaryGradientButton
                            onClick={onLoadMore}
                            buttonText="Show More"
                          />
                        </Col>
                      </Row>
                    </Container> */}
                    {/* )} */}
                  </Col>
                )}
              </>
            
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MemberPerformance;

